import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

// eslint-disable-next-line rxjs/finnish
export function jwtHttpInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> {
  const authService = inject(AuthService);
  if (req.url.includes(`/api`)) {
    return from(authService.getAccessToken()).pipe(
      switchMap(accessToken => {
        if (accessToken !== undefined) {
          const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } });
          return next(authReq);
        }
        return next(req);
      }),
    );
  }
  return next(req);
}
